import { TextField } from '@mui/material';
import ValidatedTextField from 'common-mui/components/ValidatedTextField';
import React from 'react';
import { PatternFormat } from 'react-number-format';
import { useFormContext } from 'react-hook-form';

const VerifyInput = React.forwardRef((props, ref) => {
  const { onChange, ...other } = props;
  return (
    <PatternFormat
      {...other} // eslint-disable-line react/jsx-props-no-spreading
      getInputRef={ref}
      format="######"
      onValueChange={(values) => onChange(values.formattedValue)}
    />
  );
});

const InputVerificationCode = () => {
  const { control } = useFormContext();
  return (
    <ValidatedTextField
      name="verificationCode"
      control={control}
      rules={{
        required: 'This field is required.',
        pattern: {
          value: /^\d{6}$/,
          message: 'Please enter 6 numbers',
        },
      }}
    >
      <TextField
        fullWidth
        label="Verification Code"
        InputProps={{ inputComponent: VerifyInput }}
      />
    </ValidatedTextField>
  );
};

export default InputVerificationCode;
